import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface ConversationHeaderOverflowButtonProps {
  value: number;
  isExpanded?: boolean;
  onClick?: Handler;
}

/*
 * Style.
 */

const StyledExpandButton = styled(ChromelessButton)`
  margin: 3px 6px 3px 0;
  padding: 3px 5px;

  color: ${(p) => p.theme.greys.white};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.bold};
  line-height: 16px;

  background-color: ${(p) => p.theme.greys.shade70};
  border-radius: 3px;

  &:hover {
    background-color: ${(p) => p.theme.greys.shade80};
  }
`;

/*
 * Components.
 */

export const ConversationHeaderOverflowButton: FC<ConversationHeaderOverflowButtonProps> = (props) => {
  const content = props.isExpanded ? <Icon name="chevronUpSmall" /> : `+${props.value}`;
  return <StyledExpandButton onClick={props.onClick}>{content}</StyledExpandButton>;
};
